export default __webpack_public_path__ + "static/media/78d56b7ddda1e75b437c4cc0caa15e06.155e68a1.png";